import { createAction } from 'redux-actions';
import {
  REQUEST_BRANDS_LIST_SUCCESS,
  REQUEST_BRANDS_LIST_FAILURE,
} from '../constants/actionTypes';
import * as Brand from '../api/brandsList';
import { showErrorSnackbar } from './snackbar';
import { logout } from './authentication';

const requestBrandListSuccess = createAction(REQUEST_BRANDS_LIST_SUCCESS);
const requestBrandListFailure = createAction(REQUEST_BRANDS_LIST_FAILURE);

/* eslint-disable import/prefer-default-export */
export function requestBrandsList() {
  return dispatch => Brand.requestBrandsList()
    .then(({ data }) => {
      dispatch(requestBrandListSuccess(data))})
    .catch(error => {
      dispatch(requestBrandListFailure(error?.response?.data?.errors?.error))
      if(error?.response?.status === 401){
        dispatch(showErrorSnackbar('Session is Expired!!!'));
        dispatch(logout());
      }
    });
}
